/* @generated */

// src/mini/lock.tsx
import * as React from "react";

// src/index.css.ts
var miniIllustrationStyle = "dig-13or4mr0_4-3-0";

// src/mini/lock.tsx
var LockMini = ({ altText, ...rest }) => {
  const classNames = `dig-Illustration ${miniIllustrationStyle} dig-Illustration-mini`;
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      role: "presentation",
      ...rest,
      className: classNames,
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React.createElement("title", null, altText),
    /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M57.05 48.38c-.174.176-6.328.359-13.675.405-9.453.06-13.653.302-14.366.828-.93.684-.973 3.29-.558 33.704.38 27.904.587 33.099 1.344 33.863.78.785 5.456.852 36.255.522 19.448-.209 35.743-.503 36.211-.653 1.531-.491-.138-66.304-1.723-67.902-.49-.495-6.928-.757-21.932-.893-11.681-.107-21.38-.05-21.555.127Z",
        fill: "#B4DC19"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M58.973 60.315c-8.64 1.688-11.504 7.816-7.58 16.214l1.694 3.625-1.373 10.72c-2.062 16.105-2.915 14.796 9.425 14.471 16.58-.435 17.674-1.77 14.13-17.22-1.468-6.394-1.453-8.085.086-9.51 8.272-7.657-3.508-20.816-16.382-18.3Zm9.248 4.714c3.537 3.803 3.536 7.484-.002 12.523-2.148 3.059-2.165 3.733-.297 11.376 2.203 9.02 2.477 12.116 1.103 12.48-2.724.724-11.424-.241-11.424-1.266 0-1.451 2.85-18.998 3.266-20.107.211-.562-.131-1.283-.856-1.802-3.211-2.3-4.032-9.49-1.378-12.08 4.104-4.006 6.633-4.302 9.588-1.124Z",
        fill: "#1E1919"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M54.356 5.287C37.55 7.941 33.221 16.317 35.921 40.961c1.074 9.802 1.217 10.138 3.776 8.81l1.825-.947.227-13.451c.35-20.788 3.95-26.197 18.353-27.583 20.942-2.016 25.354 4.645 25.464 38.446l.012 3.776h2.75c5.11 0 5.078.069 5.078-10.852 0-19.674-1.804-24.607-11.044-30.202-5.325-3.223-19.266-5.05-28.006-3.67Zm49.559 7.13c-1.177.828-4.686 12.981-4.043 14.003 1.689 2.683 6.28.149 7.382-4.076a225.098 225.098 0 0 1 1.698-6.05c.833-2.796.843-3.282.081-3.766-1.047-.665-4.233-.734-5.118-.112ZM58.181 16.56c-.662.175-2.223.58-3.47.901-6.667 1.718-8.572 6.213-8.572 20.223 0 11.697.29 12.689 3.391 11.604 2.55-.892 2.93-2.445 2.93-11.98 0-11.823 1.74-16.2 7.166-18.022 6.758-2.271 12.698.98 12.71 6.956.002 1.278.258 3.955.57 5.948.31 1.993.706 6.72.88 10.502.365 8.008.147 7.577 3.586 7.06 4.115-.62 4.097-.546 3.37-13.381-.709-12.538-1.162-14.212-4.451-16.459-3.73-2.546-13.972-4.441-18.11-3.352Zm59.302 6.375a1054.224 1054.224 0 0 1-4.745 3.4c-5.553 3.936-6.333 5.387-4.246 7.9 1.116 1.345 1.27 1.376 2.285.454.599-.544 1.281-.989 1.517-.989.235 0 2.99-2.067 6.121-4.594l5.693-4.594-1.018-1.73c-1.471-2.497-1.943-2.484-5.607.153Zm1.322 16.268c-8.961 1.044-10.647 2.164-8.07 5.356l1.071 1.327 7.208-.996c3.965-.548 7.43-1.215 7.701-1.483.839-.828-1.207-4.883-2.419-4.796-.597.043-3.067.31-5.491.592Z",
        fill: "currentColor"
      }
    ))
  );
};
export {
  LockMini
};
